
import { Options, Vue } from "vue-class-component";
import Accordion from "@/app/ui/components/accordion/index.vue";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import {
  formatByCountry,
  formatDateNormal,
  resolveCountry,
  whatsapp
} from "@/app/infrastructures/misc/Utils";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import {
  CourierPartnerCodDashboard,
  DetailCourierPerStatusCodDashboardData
} from "@/domain/entities/Dashboard";
import PopupSetorHarian from "../components/popup-setor-harian-kurir-v2.vue";
import { FlagsPermissionCodReconcile } from "@/feature-flags/cod-reconcile";
import { CodReconcileController } from "@/app/ui/controllers/CodReconcileController";
import {
  CourierDetailApiRequest,
  CourierDetailPendingReconcile,
  CourierSummary,
  SttInDelivery,
  CourierHistory
} from "@/domain/entities/CodReconcile";
import PopupHarusDisetor from "@/app/ui/views/cod-delivery-v2/components/popup-harus-disetor.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { GetCourierNotes } from "@/data/payload/api/CodReconcileApiRequest";
import PopupBerhasilSetorPaket from "./popup-berhasil-setor-paket.vue";
import moment from "moment";
import { configDates } from "@/app/infrastructures/misc/common-library/modules/Date";

@Options({
  components: {
    Accordion,
    PopupSetorHarian,
    PopupHarusDisetor,
    PopupBerhasilSetorPaket
  }
})
export default class Detail extends Vue {
  successDeliveryExpand = false;
  failedDeliveryExpand = false;
  onDeliveryExpand = false;
  dailyDepositFromAmountDue = false;
  openPopupAmountDue = false;
  onDeliveryFilterDate?: Date = new Date();
  summaryDetail = new CourierSummary();
  deliverySummaryDetail = new CourierSummary();
  formatPrice = (value: number) => formatByCountry(value, { type: "money", prefix: this.prefixCurrency });
  filterDate = new Date();
  pendingReconcileData: CourierDetailPendingReconcile[] = [];
  dailyDepositDateFilterDate: any = null;
  isFromPopupAmountDue = false;

  // loader
  successDeliveryLoading = false;
  failedDeliveryLoading = false;
  onDeliveryLoading = false;
  detailCourierLoading = false;

  errorCause = "";
  isLoading = false;

  dataHistoryAmount: any = [];
  dataHistoryPackage: any = [];
  modalPopUpBerhasilSetorPaket = false;
  detailSetorUang = new CourierHistory();

  get prefixCurrency() {
    return resolveCountry() === "MY" ? "RM" : "Rp";
  }

  mounted() {
    this.filterDate = this.date;
    this.dailyDepositDateFilterDate = this.date;
    DashboardController.setPhoneNumberCourier(this.driverPhone);
    DashboardController.setFilterDateCodDashboard(this.date);
    DashboardController.setSttDataCourierData([]);
    this.fetchDetailCourier();
  }
  get maxDate() {
    return new Date();
  }
  get driverPhone(): string {
    return decodeURIComponent(
      this.$route.query["driver-phone"] as string
    ).replaceAll("+", "");
  }
  get dashboardDeliveryCourierDetail() {
    return CodReconcileController.dashboardDeliveryCourierDetail;
  }

  get partnerName() {
    const splittedString = this.dashboardDeliveryCourierDetail.partnerName.split(
      " "
    );
    return splittedString.slice(0, splittedString.length - 1).join(" ");
  }

  get courier3lc() {
    const splittedString = this.dashboardDeliveryCourierDetail.partnerName.split(
      " "
    );

    const splitted3lc = splittedString[splittedString.length - 1].split("-");

    return splitted3lc[0].replace("[", "");
  }

  formattedDate(date: string) {
    if (!date) return "-";

    const timezone =
      AccountController.accountData.account_type_detail.partnerLocation?.city
        ?.timezone;
    const utcOffset = timezone.replace("GMT+", "+0").replace(":", "");
    const tzName = configDates(timezone)["id"];

    const formatDate = moment(date)
      .utcOffset(utcOffset)
      .format("DD MMM YYYY, HH.mm");

    return `${formatDate} ${tzName}`;
  }

  get columns() {
    return [
      {
        name: this.$t("codReconcile.detail.tanggal"),
        styleHead: "w-20 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left">${this.formattedDate(
            item.updatedAt
          )}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.dailyDeposit.nominalUang"),
        styleHead: "w-20 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left">${this.formatPrice(
            item.amount
          )}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.dailyDeposit.totalStt"),
        styleHead: "w-20 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left">
            <span class="font-bold">
              ${item.stt.length} STT
            </span>
            (${item.totalPiece} ${this.$t("codReconcile.dailyDeposit.koli")})
            </div>`;
        }
      },
      ...this.columnsEnd
    ];
  }

  get columnsEnd() {
    return [
      {
        name: this.$t("codReconcile.dailyDeposit.catatan"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left break-all">${item?.note || "-"}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.detail.detail"),
        key: "button_column",
        styleHead: "w-20 text-left",
        styleButton: (item: CourierHistory) => {
          return {
            flat: true,
            compact: true,
            outline: false,
            title: this.$t("codReconcile.detail.lihatDetail"),
            textColor: "blue-lp-700",
            customClass: "font-semibold underline text-base",
            small: false,
            clickFunction: () => this.popUpBerhasilSetorPacket(item)
          };
        }
      }
    ];
  }

  get columnsPackage() {
    return [
      {
        name: this.$t("codReconcile.detail.tanggal"),
        styleHead: "w-20 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left">${this.formattedDate(item.updatedAt)}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.dailyDeposit.totalStt"),
        styleHead: "w-20 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left">
            <span class="font-bold">
              ${item.stt.length} STT
            </span>
            (${item.totalPiece} ${this.$t("codReconcile.dailyDeposit.koli")})
            </div>`;
        }
      },
      ...this.columnsPackageEnd
    ];
  }

  get columnsPackageEnd() {
    return [
      {
        name: this.$t("codReconcile.dailyDeposit.catatan"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: CourierHistory) => {
          return `<div class="overflow-ellipsis text-left break-all">${item?.note || "-"}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.detail.detail"),
        key: "button_column",
        styleHead: "w-20 text-left",
        styleButton: (item: CourierHistory) => {
          return {
            flat: true,
            compact: true,
            outline: false,
            title: this.$t("codReconcile.detail.lihatDetail"),
            textColor: "blue-lp-700",
            customClass: "font-semibold underline text-base",
            small: false,
            clickFunction: () => this.popUpBerhasilSetorPacket(item)
          };
        }
      }
    ];
  }

  popUpBerhasilSetorPacket(data: CourierHistory) {
    this.modalPopUpBerhasilSetorPaket = !this.modalPopUpBerhasilSetorPaket;
    this.detailSetorUang = data;
  }

  fetchDetailCourier() {
    this.detailCourierLoading = true;
    this.errorCause = "";
    CodReconcileController.getDashboardDeliveryCourierDetail(this.driverPhone)
      .then(() => {
        this.fetchSummaryCodDashboard();
        this.getDetailSummaryByCourier();
        this.getDetailSummaryByCourier(true);
        this.getPendingReconcile();
        this.getHistoryAmount();
        this.getHistoryPackage();
      })
      .catch((err) => {
        this.errorCause = err.response ? "server" : "internet";
      })
      .finally(() => {
        this.detailCourierLoading = false;
      });
  }

  goBack() {
    this.$router.push(this.$route.meta.before as string);
  }
  downloadDeposit() {
    this.dailyDepositDateFilterDate = this.filterDate;
    const { fullname } = this.dashboardDeliveryCourierDetail;

    // Populate detailDataCourier with data from dashboardDeliveryCourierDetail
    this.detailDataCourier.courierId = String(
      this.dashboardDeliveryCourierDetail.courierId
    );
    this.detailDataCourier.courierName = this.dashboardDeliveryCourierDetail.fullname;
    this.detailDataCourier.courierPhone = this.dashboardDeliveryCourierDetail.phoneNumber;
    this.detailDataCourier.partnerName = this.dashboardDeliveryCourierDetail.partnerName;

    const state = { courier: JSON.stringify(this.detailDataCourier) };

    this.$router.push({
      name: "Detail shuttle",
      params: {
        phonenumber: Number(this.detailDataCourier.courierPhone) // path param
      },
      query: {
        date: moment(this.filterDate).format("YYYY-MM-DD") // query param
      },
      state
    });
  }
  downloadDetail() {
    DashboardController.setFilterDateCodDashboard(this.filterDate);
    // to do download detail
    DashboardController.getCourierDetailDownload({
      driverPhone: this.driverPhone,
      isPic: this.type !== "courier",
      version: "v2"
    });
  }
  async getHistoryAmount() {
    try {
      const resp = await CodReconcileController.getCourierHistory(
        new GetCourierNotes({
          courierId: Number(this.dashboardDeliveryCourierDetail.courierId),
          date: this.$moment(this.filterDate).format("YYYY-MM-DD") as string,
          reconcileFor: "COD_AMOUNT"
        })
      );

      this.dataHistoryAmount = resp;
    } catch (error) {
      console.error(error);
    }
  }
  async getHistoryPackage() {
    try {
      const resp = await CodReconcileController.getCourierHistory(
        new GetCourierNotes({
          courierId: Number(this.dashboardDeliveryCourierDetail.courierId),
          date: this.$moment(this.filterDate).format("YYYY-MM-DD") as string,
          reconcileFor: "PACKAGE"
        })
      );

      this.dataHistoryPackage = resp;
    } catch (error) {
      console.error(error);
    }
  }

  get detail() {
    const detail = {
      title: this.type === "courier" ? this.$t("codReconcile.detailCourierTitle") : this.$t("codReconcile.detailPicShuttleTitle"),
      name: this.type === "courier" ? this.$t("codReconcile.detail.courierName") : this.$t("codReconcile.detail.picShuttleName"),
      setor: this.$t("codReconcile.list.setorHarian")
    };

    return detail;
  }

  get isConsole() {
    return AccountController.accountData.isConsoleAccount;
  }

  get isSubConsole() {
    return AccountController.accountData.isSubConsoleAccount;
  }

  get type() {
    return this.$route.query["type"];
  }
  get date(): Date {
    return new Date(this.$route.query["date"] as string);
  }
  get showButtonDeposit() {
    return this.type === "courier"
      ? FlagsPermissionCodReconcile.permission_cod_reconcile_deposit.isEnabled() ||
          this.isConsole ||
          this.isSubConsole
      : FlagsPermissionCodReconcile.permission_cod_reconcile_pic_deposit.isEnabled();
  }

  get successfulDeliverySummary() {
    return (
      this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "POD"
      ) || new SttInDelivery()
    );
  }

  get failedDeliverySummaryTotalStt() {
    return (
      (this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "CODREJ"
      )?.count || 0) +
      (this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "DEX"
      )?.count || 0)
    );
  }

  get failedDeliverySummaryTotalPieces() {
    return (
      (this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "CODREJ"
      )?.pieces || 0) +
      (this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "DEX"
      )?.pieces || 0)
    );
  }

  get onDeliverySummary() {
    return (
      this.deliverySummaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "DEL"
      ) || new SttInDelivery()
    );
  }

  get codAmountDepositPending() {
    return this.formatPrice(this.summaryDetail.codAmountDeposit.pending);
  }

  get sttDepositTotalPieces() {
    return this.summaryDetail.sttDeposit.reduce(
      (a, b) => a + b.pendingPieces,
      0
    );
  }

  get sttDepositTotal() {
    return this.summaryDetail.sttDeposit.reduce((a, b) => a + b.pending, 0);
  }

  get totalCodAmount() {
    return this.formatPrice(
      this.summaryDetail.codAmountDeposit.pending +
        this.summaryDetail.codAmountDeposit.collected
    );
  }

  get pendingCodAmount() {
    return this.formatPrice(this.summaryDetail.codAmountDeposit.pending);
  }

  get collectedCodAmount() {
    return this.formatPrice(this.summaryDetail.codAmountDeposit.collected);
  }

  // DEX
  get totalDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );
    return (totalDex?.pending || 0) + (totalDex?.collected || 0);
  }

  get totalPiecexDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );
    return (totalDex?.collectedPieces || 0) + (totalDex?.pendingPieces || 0);
  }

  get pendingDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );

    return totalDex?.pending || 0;
  }

  get pendingPiecexDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );

    return totalDex?.pendingPieces || 0;
  }

  get collectedDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );

    return totalDex?.collected || 0;
  }

  get collectedPiecexDex() {
    const totalDex = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "DEX"
    );

    return totalDex?.collectedPieces || 0;
  }

  // CODREJ
  get totalCodrej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );
    return (totalCodrej?.pending || 0) + (totalCodrej?.collected || 0);
  }

  get totalPiecesCodrej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );
    return (
      (totalCodrej?.collectedPieces || 0) + (totalCodrej?.pendingPieces || 0)
    );
  }

  get pendingCodRej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );

    return totalCodrej?.pending || 0;
  }

  get pendingPiecesCodrej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );

    return totalCodrej?.pendingPieces || 0;
  }

  get collectedCodrej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );

    return totalCodrej?.collected || 0;
  }

  get collectedPieceCodrej() {
    const totalCodrej = this.summaryDetail.sttDeposit.find(
      (item) => item.status.toUpperCase() === "CODREJ"
    );

    return totalCodrej?.collectedPieces || 0;
  }

  // in delivery
  get totalInDelivery() {
    return this.summaryDetail.sttInDelivery.reduce((a, b) => a + b.count, 0);
  }

  get totalPiecesInDelivery() {
    return this.summaryDetail.sttInDelivery.reduce((a, b) => a + b.pieces, 0);
  }

  get totalDelInDelivery() {
    return (
      this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "DEL"
      )?.count || 0
    );
  }

  get totalPiecesDelInDelivery() {
    return (
      this.summaryDetail.sttInDelivery.find(
        (item) => item.status.toUpperCase() === "DEL"
      )?.pieces || 0
    );
  }

  get totalPodCodrejDex() {
    return this.summaryDetail.sttInDelivery
      .filter((item) => item.status.toUpperCase() !== "DEL")
      .reduce((a, b) => a + b.count, 0);
  }

  get totalPiecesPodCodrejDex() {
    return this.summaryDetail.sttInDelivery
      .filter((item) => item.status.toUpperCase() !== "DEL")
      .reduce((a, b) => a + b.pieces, 0);
  }

  listOfDetailPerStatus: DetailCourierPerStatusCodDashboardData[] = [
    new DetailCourierPerStatusCodDashboardData({
      status: "success",
      loading: true
    }),
    new DetailCourierPerStatusCodDashboardData({
      status: "failed",
      loading: true
    }),
    new DetailCourierPerStatusCodDashboardData({
      status: "onprogress",
      loading: true
    })
  ];
  async fetchSummaryCodDashboard(firstLoad = true) {
    // fetch success status
    this.successDeliveryLoading = true;
    CodReconcileController.getCourierDetailPerStatus({
      params: new CourierDetailApiRequest({
        driverPhone: this.driverPhone,
        filterDate: formatDateNormal(this.filterDate, "YYYY-MM-DD"),
        picPhone: this.driverPhone,
        status: "success",
        type: this.type as string,
        isAllType: true
      }),
      version: "v3"
    }).finally(() => {
      this.successDeliveryLoading = false;
    });

    // fetch failed status
    this.failedDeliveryLoading = true;
    CodReconcileController.getCourierDetailPerStatus({
      params: new CourierDetailApiRequest({
        driverPhone: this.driverPhone,
        filterDate: formatDateNormal(this.filterDate, "YYYY-MM-DD"),
        picPhone: this.driverPhone,
        status: "failed",
        type: this.type as string,
        isAllType: true
      }),
      version: "v3"
    }).finally(() => {
      this.failedDeliveryLoading = false;
    });

    if (firstLoad) {
      // fetch onprogress status
      this.onDeliveryLoading = true;
      CodReconcileController.getCourierDetailPerStatus({
        params: new CourierDetailApiRequest({
          driverPhone: this.driverPhone,
          filterDate: formatDateNormal(this.onDeliveryFilterDate, "YYYY-MM-DD"),
          picPhone: this.driverPhone,
          status: "onprogress",
          type: this.type as string,
          isAllType: true
        }),
        version: "v3"
      }).finally(() => {
        this.onDeliveryLoading = false;
      });
    }
  }

  get successfulDelivery() {
    return CodReconcileController.courierDetailListSuccess;
  }

  get failedDelivery() {
    return CodReconcileController.courierDetailListFailed;
  }

  get onDelivery() {
    return CodReconcileController.courierDetailListOnProgress;
  }

  getCodAmount(item: any) {
    return formatByCountry(item.sttCodAmount, { type: "money", prefix: this.prefixCurrency });
  }

  columnData(params: {
    name: string;
    key: string;
    styleHead?: string;
    styleBody?: string;
  }) {
    const { name, key, styleHead, styleBody } = params;
    return {
      name,
      styleHead: `${styleHead} text-left whitespace-no-wrap`,
      styleBody: `${styleBody} text-center`,
      render: (item: any) => {
        return `<div class='text-left text-gray-lp-300'>${item[key]}</div>`;
      }
    };
  }
  get rowsData() {
    return [
      this.columnData({
        name: this.$t("codReconcile.dailyDeposit.noStt"),
        styleHead: "w-40 text-sm",
        key: "sttNo"
      }),
      this.columnData({
        name: this.$t("codReconcile.detail.statusTerakhir"),
        styleHead: "w-50 text-sm",
        key: "sttStatus"
      }),
      this.columnData({
        name: this.$t("codReconcile.detail.tipePembayaranCod"),
        styleHead: "w-50 text-sm",
        key: "sttPaymentMethod"
      }),
      this.columnData({
        name: this.$t("codReconcile.detail.statusSetoran"),
        styleHead: "w-50 text-sm",
        key: "sttCollectionStatus"
      })
    ];
  }
  get rows() {
    return [
      {
        name: this.$t("codReconcile.list.no"),
        styleHead: "w-20 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any, index: any) => {
          return `<div class='text-left text-gray-lp-300'>${index + 1}</div>`;
        }
      },
      ...this.rowsData,
      {
        name: this.$t("codReconcile.detail.nilaiCod"),
        styleHead: "w-50 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any) => {
          return this.renderCodAmount(item);
        }
      }
    ];
  }
  get columnSuccessful() {
    const courierName: any = {
      name: this.$t("codReconcile.list.courierName"),
      styleHead: "w-50 text-left whitespace-nowrap",
      render: (item: any) => {
        return (
          `<div class='text-black-lp-300'>${item.sttDriverName}</div>` +
          `<div class='text-black-lp-300'>${item.sttDriverPhone}</div>`
        );
      },
      showButton: (item: any) => {
        return item.sttDriverPhone;
      },
      styleCustom: "items-end"
    };

    if (this.type === "pic") {
      return this.rows.splice(2, 0, courierName);
    }

    return this.rows;
  }

  get rowsFailed() {
    return [
      {
        name: this.$t("codReconcile.list.no"),
        styleHead: "w-20 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any, index: any) => {
          return `<div class='text-left text-gray-lp-300'>${index + 1}</div>`;
        }
      },
      this.columnData({
        name: this.$t("codReconcile.dailyDeposit.noStt"),
        styleHead: "w-40 text-sm",
        key: "sttNo"
      }),
      {
        name: this.$t("codReconcile.detail.statusSetoranLast"),
        styleHead: "w-50 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any) => {
          return `<div class='text-left text-gray-lp-300'>${item.sttStatus}</div>`;
        }
      },
      this.columnData({
        name: this.$t("codReconcile.detail.statusSetoran"),
        styleHead: "w-50 text-sm",
        key: "sttCollectionStatus"
      }),
      this.columnData({
        name: this.$t("codReconcile.detail.alasan"),
        styleHead: "w-50 text-sm",
        key: "sttReason"
      }),
      {
        name: this.$t("codReconcile.detail.namaPenerima"),
        styleHead: "w-50 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any) => {
          return `
            <div>
              <div class='text-left text-gray-lp-300'>${
                item.sttRecipientName
              }</div>
              <div class="flex flex-row items-center font-semibold gap-2">
                <div class='text-left text-gray-lp-300'>${
                  item.sttRecipientPhone
                }</div>
                <img src="${require("@/app/ui/assets/svg/ics_f_whatsapp.svg")}" />
              </div>
            </div>
          `;
        },
        onClickValue: (item: any) => {
          window.open(
            `https://api.whatsapp.com/send?phone=${item.sttRecipientPhone}`,
            "_blank"
          );
        }
      }
    ];
  }
  get columnFailed() {
    const courierName: any = {
      name: this.$t("codReconcile.list.courierName"),
      styleHead: "w-50 text-left whitespace-nowrap text-sm",
      render: (item: any) => {
        return (
          `<div class='text-black-lp-300'>${item.sttDriverName}</div>` +
          `<div class='text-black-lp-300'>${item.sttDriverPhone}</div>`
        );
      },
      showButton: (item: any) => {
        return item.sttDriverPhone;
      },
      styleCustom: "items-end"
    };

    if (this.type === "pic") {
      this.rowsFailed.splice(2, 0, courierName);
    }

    return this.rowsFailed;
  }

  onCLickWhatsapp() {
    return true;
  }

  get columnOnDelivery() {
    return [
      {
        name: this.$t("codReconcile.list.no"),
        styleHead: "w-20 text-left whitespace-no-wrap text-sm",
        styleBody: "text-center",
        render: (item: any, index: any) => {
          return `<div class='text-left text-gray-lp-300'>${index + 1}</div>`;
        }
      },
      {
        name: this.$t("codReconcile.dailyDeposit.noStt"),
        styleHead: "w-40 text-left whitespace-no-wrap text-sm",
      styleBody: "text-center",
      render: (item: any) => {
        return `<div class='text-left text-gray-lp-300'>${item.sttNo}</div>`;
      }
    },
    {
      name: this.$t("codReconcile.detail.tanggalDel"),
      styleHead: "w-50 text-left whitespace-no-wrap text-sm",
      styleBody: "text-center",
      render: (item: any) => {
        return `<div class='text-left text-gray-lp-300'>${formatDateNormal(
          item.sttDeliveryDate,
          "DD MMMM YYYY"
        )}</div>`;
      }
    },
    {
      name: this.$t("codReconcile.detail.statusSetoranLast"),
      styleHead: "w-50 text-left whitespace-no-wrap text-sm",
      styleBody: "text-center",
      render: (item: any) => {
        return `<div class='text-left text-gray-lp-300'>${item.sttStatus}</div>`;
      }
    },
    {
      name: this.$t("codReconcile.detail.nilaiCod"),
      styleHead: "w-50 text-left whitespace-no-wrap text-sm",
      styleBody: "text-center",
      render: (item: any) => {
        return this.renderCodAmount(item);
      }
    },
    {
      name: this.$t("codReconcile.detail.namaPenerima"),
      styleHead: "w-50 text-left whitespace-no-wrap text-sm",
      styleBody: "text-center",
      render: (item: any) => {
        return `
          <div>
            <div class='text-left text-gray-lp-300'>${
              item.sttRecipientName
            }</div>
            <div class="flex flex-row items-center font-semibold gap-2">
              <div class='text-left text-gray-lp-300'>${
                item.sttRecipientPhone
              }</div>
              <img src="${require("@/app/ui/assets/svg/ics_f_whatsapp.svg")}" />
            </div>
          </div>
        `;
      },
      onClickValue: (item: any) => {
        window.open(
          `https://api.whatsapp.com/send?phone=${item.sttRecipientPhone}`,
          "_blank"
        );
      }
    }
  ];
  }

  renderCodAmount(item: any) {
    return `<div data-testid="cod-reconcile-stt-cod-amount" class='text-left text-gray-lp-300'>${this.getCodAmount(
      item
    )}</div>`;
  }

  // table
  get firstRowHeaderColumns() {
    const rows = [
      {
        name: this.$t("codReconcile.detail.performaPengiriman"),
        colSpan: 2,
        styleHead:
          "w-500px text-center whitespace-no-wrap border-horizontal-separation"
      },
      {
        name: this.$t("codReconcile.detail.dalamPengiriman"),
        styleHead: "w-48 text-center whitespace-no-wrap"
      },
      {
        name: this.$t("codReconcile.detail.pengirimanBerhasil"),
        colSpan: 3,
        styleHead:
          "w-500px text-left whitespace-no-wrap border-horizontal-separation"
      },
      {
        name: this.$t("codReconcile.detail.pengirimanGagal"),
        colSpan: 4,
        styleHead:
          "w-500px text-left whitespace-no-wrap border-horizontal-separation"
      }
    ];

    return this.type === "courier" ? rows : rows.slice(2);
  }
  get tooltipHeaderBelumSetor() {
    return (
      "<div class='text-black-lp-300 text-12px text-left'>" +
      "Total nilai COD dari STT COD yang telah berhasil dikirim (POD) tetapi belum disetor oleh kurir kepada admin POS." +
      "</div>"
    );
  }
  get tooltipHeaderSudahSetor() {
    return (
      "<div class='text-black-lp-300 text-12px text-left'>" +
      "Total nilai COD dari STT COD yang telah berhasil dikirim (POD) dan telah disetor oleh kurir kepada admin POS." +
      "</div>"
    );
  }
  // data table
  get dataCourierPartner() {
    return [
      {
        performance: 1,
        onProccess: 2
      }
    ];
  }

  onClickWhatsapp() {
    const templateMessage =
      `Halo ${this.dashboardDeliveryCourierDetail.fullname}\n` +
      `Kami menginformasikan ada STT COD perlu diselesaikan proses secepatnya:\n` +
      `${this.totalDelInDelivery +
        this.pendingDex} STT COD masih proses pengiriman\n` +
      `${this.pendingDex +
        this.pendingCodRej} STT COD harus dikembalikan ke POS\n` +
      `${this.totalCodAmount} Dana harus disetor ke POS\n` +
      `Harap langsung memproses pengiriman STT dan lakukan penyetoran
       Terima kasih`;

    whatsapp(this.driverPhone, templateMessage);
  }

  popupSetorHarianModelValue = false;
  detailDataCourier = new CourierPartnerCodDashboard();
  popUpSetorHarian(bool: boolean, data: CourierPartnerCodDashboard) {
    this.detailDataCourier = data;
    this.popupSetorHarianModelValue = bool;
  }

  get dailyDepositDateFilterDateString() {
    return formatDateNormal(this.dailyDepositDateFilterDate, "YYYY-MM-DD");
  }

  onDeliveryDateSelected(val: any) {
    this.onDeliveryFilterDate = val;
    this.onDeliveryLoading = true;
    CodReconcileController.getCourierDetailPerStatus({
      params: new CourierDetailApiRequest({
        driverPhone: this.driverPhone,
        filterDate: val
          ? formatDateNormal(this.onDeliveryFilterDate, "YYYY-MM-DD")
          : formatDateNormal(new Date(), "YYYY-MM-DD"),
        picPhone: this.driverPhone,
        status: "onprogress",
        type: this.type as string,
        isAllType: true
      }),
      version: "v3"
    }).finally(() => {
      this.onDeliveryLoading = false;
    });
    this.getDetailSummaryByCourier(true);
  }

  getDetailSummaryByCourier(isForDelivery = false) {
    MainAppController.showLoading();
    let filterDate: any = formatDateNormal(this.filterDate, "YYYY-MM-DD");

    if (isForDelivery) {
      filterDate = this.onDeliveryFilterDate
        ? formatDateNormal(this.onDeliveryFilterDate, "YYYY-MM-DD")
        : formatDateNormal(new Date(), "YYYY-MM-DD");
    }

    CodReconcileController.getCourierSummaryDetailV2({
      params: new CourierDetailApiRequest({
        driverPhone: this.driverPhone.replace(/^\+/, ""),
        type: this.type === "courier" ? "DRIVER" : (this.type as string),
        filterDate: filterDate,
        hubId: getHubData()?.hubId || 0
      }),
      version: "v3"
    })
      .then((res) => {
        if (isForDelivery) {
          this.deliverySummaryDetail = res;
        } else {
          this.summaryDetail = res;
        }
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  getPendingReconcile() {
    CodReconcileController.getDetailCourierPendingReconcile({
      params: new CourierDetailApiRequest({
        filterDate: formatDateNormal(this.filterDate, "YYYY-MM-DD"),
        driverPhone: this.driverPhone
      }),
      version: "v3"
    }).then((res) => {
      this.pendingReconcileData = res;
    });
  }

  onFilterDate() {
    this.fetchSummaryCodDashboard(false);
    this.getDetailSummaryByCourier();
    this.getPendingReconcile();
    this.getHistoryAmount();
    this.getHistoryPackage();
  }

  openDailyDepositFromAmountDue(data: CourierDetailPendingReconcile) {
    this.$router.push({
      name: "Detail shuttle",
      params: {
        phonenumber: this.detailDataCourier.courierPhone // path param
      },
      query: {
        date: moment(data.dateGroup).format("YYYY-MM-DD") // query param
      },
      state: {
        courier: JSON.stringify(this.detailDataCourier)
      }
    });
  }

  onClickOpenPopupAmountDue() {
    this.openPopupAmountDue = true;
    this.detailDataCourier.courierId = String(
      this.dashboardDeliveryCourierDetail.courierId
    );
    this.detailDataCourier.courierName = this.dashboardDeliveryCourierDetail.fullname;
    this.detailDataCourier.courierPhone = this.driverPhone;
  }

  closeAmountDue(data: any) {
    this.openPopupAmountDue = data;
  }

  onCloseDepositDaily(success = false) {
    if (this.isFromPopupAmountDue && !success) {
      this.onClickOpenPopupAmountDue();
    }
    if (success) {
      this.fetchDetailCourier();
    }
  }

  activeMenu = "detail-stt";
  get tabs() {
    return [
      { value: "detail-stt", title: this.$t("codReconcile.detail.tabDetailStt") },
      { value: "riwayat-setor-uang", title: this.$t("codReconcile.detail.tabRiwayatSetorUang") },
      { value: "riwayat-setor-paket", title: this.$t("codReconcile.detail.tabRiwayatSetorPaket") }
    ];
  }

  onChangeTabs(value: string) {
    this.activeMenu = value;
  }
}
